import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { VisitorOffenderUpdateRequest } from "../../shared/VisitorOffenderUpdateRequest";
import { DataService_MultiStationViewVisitors } from "../../shared/data.service";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-ms-offender-verified-table",
	templateUrl: "./ms-offender-verified-table.component.html",
	styleUrls: ["./ms-offender-verified-table.component.css"],
})
export class MsOffenderVerifiedTableComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationViewVisitors, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() lstOffender: any = [];
	@Output() onRefresh: EventEmitter<any> = new EventEmitter();

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	SelectedOffender: any;

	lstIsMatchDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PersonName", header: "Name" },
		{ field: "DOBDesc", header: "DOB" },
		{ field: "IsMatchDesc", header: "Match" },
		{ field: "AdminName", header: "Admin" },
	];

	Processing: boolean = false;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		this.lstIsMatchDesc = Array.from(new Set(this.lstOffender.map((item: any) => item.IsMatchDesc))).sort();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onReVerify(OffenderID) {
		this.Processing = true;

		var parms: VisitorOffenderUpdateRequest = {
			OffenderID: OffenderID,
			IsOffender: 1,
			IsVerified: 0,
		};

		var result = this.visitorService.VisitorOffenderUpdateEntry(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.onRefresh.emit(true);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "offenderlookupverifiedtable",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the offender entry: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onRowSelect(val) {
		this.SelectedOffender = val.data;
	}

	onRowUnselect(val) {
		this.SelectedOffender = null;
	}

	////////////////////////////////////////////
}
